"use client"
import Grid from "@mui/material/Grid"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useRouter } from "next/navigation"
import { CancelButton, Icons, ProductCard } from "@src/components"
import { GridContainer } from "@src/components/style-box"
import { ROUTES } from "@src/constants/routes"
import { useTranslation } from "react-i18next"

function RelativeProduct({
  hiddenViewAll = false,
  label,
  relatedProducts = []
}) {
  const router = useRouter()
  const { t } = useTranslation()

  const handleRedirect = path => () => {
    router.push(path)
  }

  const renderContent = () => {
    if (relatedProducts?.length === 0) {
      return (
        <Typography
          variant="body1"
          sx={{
            marginTop: 4,
            fontSize: {
              xs: 14,
              md: 16
            },
            marginLeft: 1.5,
            fontWeight: 400,
            lineHeight: "20px"
          }}
        >
          {t("no_products_available")}
        </Typography>
      )
    }

    return (relatedProducts || [])?.map((product, index) => (
      <Grid key={index} item xs={6} lg={3}>
        <ProductCard product={product} />
      </Grid>
    ))
  }

  return (
    <Stack direction={"column"} width={"100%"}>
      <Typography
        variant="h3"
        sx={{
          fontSize: {
            xs: 16,
            md: 30
          },
          fontWeight: 700,
          lineHeight: "36px"
        }}
      >
        {label ?? t("similar_products")}
      </Typography>
      <GridContainer>{renderContent()}</GridContainer>
      {!hiddenViewAll && relatedProducts?.length > 0 && (
        <Stack
          display={{
            xs: "none",
            md: "flex"
          }}
          mt={3}
          justifyContent="center"
        >
          <CancelButton
            label={t("see_more")}
            height={"44px"}
            endIcon={<Icons name="arrow-right" />}
            sx={{
              color: "#262626 !important",
              minHeight: "44px",
              minWidth: "300px"
            }}
            onClick={handleRedirect(ROUTES.PRODUCT)}
          />
        </Stack>
      )}
    </Stack>
  )
}

export default RelativeProduct
